const COOKIE_KEYS = {
  PRODUCT_ID_KEY: 'pid',
  CART_ID_KEY: 'crtId',
  NEW_SUBSCRIPTION_KEY: 'nsid',
  ORDER_CONFIRMED_ID: 'oid',
  CART_ID_AM: 'cartIdAM',
};

export default COOKIE_KEYS;
